import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import DashboardShell from "./dashboards/DashboardShell";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { Checkbox } from "../components/ui/checkbox";
import ImageUploader from "../components/ImageUploader";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

const equipments = [
  "Wifi haut débit", "Électricité", "Parking", "Sanitaires", "Loges",
  "Sonorisation", "Éclairage", "Climatisation", "Cuisine", "Accès PMR",
];

const sampleImages = [
  "https://images.unsplash.com/photo-1772903191730-fa9bc478c1de?w=1200&q=85",
  "https://images.unsplash.com/photo-1775866914966-5bd2194c464f?w=1200&q=85",
  "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=1200&q=85",
  "https://images.pexels.com/photos/6950031/pexels-photo-6950031.jpeg?auto=compress&w=1200",
];

export default function CreateVenue() {
  const nav = useNavigate();
  const [saving, setSaving] = useState(false);
  const [v, setV] = useState({
    name: "", description: "", city: "", address: "",
    capacity: 500, price_per_day: 1000, images: [], equipment: [],
  });

  const toggle = (eq) => setV({...v, equipment: v.equipment.includes(eq) ? v.equipment.filter(x => x !== eq) : [...v.equipment, eq]});

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const images = v.images?.length ? v.images : [sampleImages[0]];
      const { data } = await api.post("/venues", {
        name: v.name, description: v.description, city: v.city, address: v.address,
        capacity: parseInt(v.capacity), price_per_day: parseFloat(v.price_per_day),
        equipment: v.equipment, images,
      });
      toast.success("Lieu publié");
      nav(`/venues/${data.id}`);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erreur");
    } finally { setSaving(false); }
  };

  return (
    <DashboardShell title="Nouveau lieu" subtitle="Publiez votre espace événementiel">
      <form onSubmit={submit} className="max-w-3xl space-y-6" data-testid="create-venue-form">
        <div className="bg-white border border-ink/10 rounded-md p-6 space-y-4">
          <div><Label>Nom</Label><Input data-testid="venue-name" required value={v.name} onChange={(e) => setV({...v, name: e.target.value})} /></div>
          <div><Label>Description</Label><Textarea data-testid="venue-description" required rows={4} value={v.description} onChange={(e) => setV({...v, description: e.target.value})} /></div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label>Ville</Label><Input data-testid="venue-city" required value={v.city} onChange={(e) => setV({...v, city: e.target.value})} /></div>
            <div><Label>Adresse</Label><Input required value={v.address} onChange={(e) => setV({...v, address: e.target.value})} /></div>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label>Capacité (pers.)</Label><Input type="number" required value={v.capacity} onChange={(e) => setV({...v, capacity: e.target.value})} /></div>
            <div><Label>Prix / jour (€)</Label><Input type="number" data-testid="venue-price" required value={v.price_per_day} onChange={(e) => setV({...v, price_per_day: e.target.value})} /></div>
          </div>
          <div>
            <Label>Photos</Label>
            <ImageUploader
              value={v.images}
              onChange={(images) => setV({ ...v, images })}
              max={5}
              presets={sampleImages}
            />
          </div>
        </div>

        <div className="bg-white border border-ink/10 rounded-md p-6">
          <h2 className="font-heading font-medium text-lg text-ink mb-4">Équipements</h2>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
            {equipments.map((eq) => (
              <label key={eq} className="flex items-center gap-2 text-sm cursor-pointer">
                <Checkbox checked={v.equipment.includes(eq)} onCheckedChange={() => toggle(eq)} />
                <span>{eq}</span>
              </label>
            ))}
          </div>
        </div>

        <Button data-testid="venue-submit" type="submit" disabled={saving} className="bg-ink hover:bg-ink/85 text-cream rounded-none">
          {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : "Publier le lieu"}
        </Button>
      </form>
    </DashboardShell>
  );
}
